// colours that don't fit into any other category

enum Misc {
  transparent = 'transparent',
}

export default Misc;
